import { ObjetKForm, requiredRule, combineRules, enumValue } from '@siclop/kstone-vue'
import { LeaveRequestStatus } from '../enums/LeaveRequestStatus'

export class LeaveRequestForm extends ObjetKForm {
  /** 0 : salarié de l'utilisateur connecté (l'écran le renseigne, l'API le prend aussi par défaut). */
  employeeId: number = 0
  /** Vide tant que rien n'est choisi (affiche le texte indicatif plutôt que « 0 »). */
  leaveTypeId: number | null = null
  /** Statut conservé à l'enregistrement : sans lui, l'API repasserait la demande en brouillon. */
  status: LeaveRequestStatus = LeaveRequestStatus.Draft
  startDate: string = ''
  endDate: string = ''
  startHalfDay: boolean = false
  endHalfDay: boolean = false
  reason: string = ''

  static validationRules = {
    leaveTypeId: combineRules(requiredRule('Le type d\'absence est obligatoire')),
    startDate: combineRules(requiredRule('La date de début est obligatoire')),
    endDate: combineRules(requiredRule('La date de fin est obligatoire'))
  }

  constructor(data?: Partial<LeaveRequestForm>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId ?? 0
      this.leaveTypeId = data.leaveTypeId || null
      this.status = enumValue(LeaveRequestStatus, data.status, LeaveRequestStatus.Draft)
      // L'API renvoie des dates avec heure ; le formulaire travaille en YYYY-MM-DD (value-format des sélecteurs)
      this.startDate = (data.startDate ?? '').slice(0, 10)
      this.endDate = (data.endDate ?? '').slice(0, 10)
      this.startHalfDay = data.startHalfDay ?? false
      this.endHalfDay = data.endHalfDay ?? false
      this.reason = data.reason ?? ''
    }
  }
}
